module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }